import React, { useEffect,  useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import { useDispatch, useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import AppContractsRefresh from '../components/AppContractsRefresh';
import AppContractAnnex from '../components/AppContractAnnex';
import AppContractSchedule from '../components/AppContractSchedule';
import EDSFooter from '../components/EDSFooter';
import { setcontractCheckbox } from '../reducers/reposReducers';

const Umowa = () => {
    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
        localStorage.clear();
      
        history.push('/Error_sesja_wygasla');
    }
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {}, []);
    let checkboxArr = useSelector((state) => state.repos.contractCheckbox);
    let autoSelect = false;
    const save = (e) => {
        let arr = [];
        arr.push(checkbox);
        arr.push(checkbox0)
        arr.push(checkbox1)
        dispatch(setcontractCheckbox(arr));
        e.preventDefault();
        history.push('/platnosc');
    };

    const [checkbox, setcheckbox] = useState((checkboxArr && checkboxArr[0] !== undefined)?checkboxArr[0] : autoSelect);
    const [checkbox0, setcheckbox0] = useState((checkboxArr && checkboxArr[1] !== undefined)?checkboxArr[1] :autoSelect);
    const [checkbox1, setcheckbox1] = useState((checkboxArr && checkboxArr[2] !== undefined)?checkboxArr[2] :autoSelect);

    let getGroup = useSelector((state) => state.repos.groups);
    let payForm = useSelector((state) => state.repos.payForm);
    let dateToBay = useSelector((state) => state.repos.date);
    let users = useSelector((state) => state.repos.users);
    let usersParticipant = useSelector((state) => state.repos.usersParticipant);
    let coursesHeadings = useSelector((state) => state.repos.coursesHeadings);
    let payZero = useSelector((state) => state.repos.payzero);
    let entryFee = useSelector((state) => state.repos.entryFee);
    let allInstallments = useSelector((state) => state.repos.allInstallments);
    let selectedInstallments = useSelector((state) => state.repos.selectedInstallments);
    const promotionsData = useSelector((state) => state.repos.promotionsData);
    let numberOfinstallments = 0;

    const allInstallmentsPrice = useSelector((state) => state.repos.allInstallmentsPrice);


    if (getGroup && getGroup.paymentShedule.length > 0) {
        let length = getGroup.paymentShedule.length
        getGroup.paymentShedule.map((x) => {
            if ( x.paymentPositionPrice > 0 
                && getGroup.paymentShedule[length -1].paymentPositionPrice === x.paymentPositionPrice  ) {
                numberOfinstallments = numberOfinstallments + 1;
            }
        });
    }

    if (!getGroup) {
        getGroup = JSON.parse(localStorage.getItem('getGroup'));
    }

    if (!payForm) {
        payForm = JSON.parse(localStorage.getItem('payForm'));
    }

    if (!dateToBay) {
        if (localStorage.getItem('dateToBay') !== 'undefined') {
            dateToBay = JSON.parse(localStorage.getItem('dateToBay'));
        }
    }

    if (!users) {
        users = JSON.parse(localStorage.getItem('users'));
    }

    if (!usersParticipant) {
        if (localStorage.getItem('usersParticipant') !== 'undefined') {
            usersParticipant = JSON.parse(localStorage.getItem('usersParticipant'));
        }
    }

    if (!coursesHeadings) {
        coursesHeadings = JSON.parse(localStorage.getItem('coursesHeadings'));
    }

    function openInNewTab(url) {
        var win = window.open(url, '_blank');
        win.focus();
    }

    function validButton(){
        if(checkbox && checkbox0 && checkbox1){
            return false
        } else {
            return true
        }
    }
    console.log("getGroup",getGroup)
    console.log("payForm",payForm)
    console.log("dateToBay",dateToBay)
    console.log("users",users)
    console.log("usersParticipant",usersParticipant)
    console.log("coursesHeadings",coursesHeadings)
    console.log("payZero",payZero)
    console.log("numberOfinstallments",numberOfinstallments)
    console.log("entryFee",entryFee)
    console.log("allInstallments",allInstallments)
    console.log("selectedInstallments",selectedInstallments)
    console.log("allInstallmentsPrice",allInstallmentsPrice)
    console.log("promotionsData.selectedPromotions",promotionsData.selectedPromotions)

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">
                        Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                    </span>
                </div>
            </header>
            <div className="content">
                <div>
                    <a href="">
                        <Link to="/Wybor_opcji_5_raty">
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                </div>
                <ProfileHeader></ProfileHeader>
                <aside className="registration-steps margin-top-32">
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">1</span>
                        </div>
                        <span className="step__text">Wybór&nbsp;kursu</span>
                    </div>
                    <div className="step">
                        <div className="step__circle step__circle--active">
                            <span className="step__count">2</span>
                        </div>
                        <span className="step__text">Umowa</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">3</span>
                        </div>
                        <span className="step__text">Płatność</span>
                    </div>
                </aside>
                <main className="responsive-padding margin-top-64">
                    <h2 className="h2">Umowa</h2>
                    <div className="text-box margin-top-32">
                        <p className="text-large">Zaakceptuj warunki umowy by przejść dalej.</p>
                        <p className="margin-top-8">
                            Jeżeli zauważysz błąd, możesz poprawić swoje dane.
                        </p>
                        <p>Masz zawsze dostęp do treści umowy z poziomu swojego profilu.</p>
                    </div>
                    <div className="contract margin-top-32">
                        <div id="elem">
                            <AppContractsRefresh
                                getGroup={getGroup}
                                payForm={payForm}
                                dateToBay={dateToBay}
                                users={users}
                                usersParticipant={usersParticipant}
                                coursesHeadings={coursesHeadings}
                                payZero={payZero}
                                numberOfinstallments={numberOfinstallments}
                                entryFee={entryFee}
                                allInstallments={allInstallments}
                                selectedInstallments={selectedInstallments}
                                allInstallmentsPrice={allInstallmentsPrice}
                                promotionsData={promotionsData.selectedPromotions}
 
                            />
                            {(promotionsData.selectedPromotions.length > 0)? 

                            <div>
                            <AppContractAnnex
                                getGroup={getGroup}
                                payForm={payForm}
                                dateToBay={dateToBay}
                                users={users}
                                usersParticipant={usersParticipant}
                                coursesHeadings={coursesHeadings}
                                payZero={payZero}
                                numberOfinstallments={numberOfinstallments}
                                entryFee={entryFee}
                                allInstallments={allInstallments}
                                selectedInstallments={selectedInstallments}
                                allInstallmentsPrice={allInstallmentsPrice}
                                promotionsData={promotionsData.selectedPromotions}
                            />
          
                             <AppContractSchedule
                                getGroup={getGroup}
                                payForm={payForm}
                                dateToBay={dateToBay}
                                users={users}
                                usersParticipant={usersParticipant}
                                coursesHeadings={coursesHeadings}
                                payZero={payZero}
                                numberOfinstallments={numberOfinstallments}
                                entryFee={entryFee}
                                allInstallments={allInstallments}
                                selectedInstallments={selectedInstallments}
                                allInstallmentsPrice={allInstallmentsPrice}
                                promotionsData={promotionsData.selectedPromotions}
                            />
                                </div>:  ''
                            }
                        </div>

                        {/* <iFrame
                            src="https://aden-eds-portal-dev.azurewebsites.net/#/app_contract"
                            style={{ width: '100%', height: 600 }}
                        > */}
                        {/* <iFrame src="http://localhost:3000/#/app_contract" style={{ width: '100%', height: 600 }}>
                        </iFrame> */}
                    </div>
                    <div className="contract__embed-actions margin-top-16">
                        <button
                            type="button"
                            id="contract-emed-download"
                            className="contract__action-icon"
                            title="Pobierz umowę"
                            onClick={() => {
                                let elems0 = document.getElementById('elem');
                                let elems = elems0.querySelectorAll('div.partPdf');
                                var imgWidth = 190;
                                var pageHeight = 290;
                                var position = 10;
                                var doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });

                                elems.forEach((elem, idx) => {
                                    html2canvas(elem, { scale: '1.5' }).then((canvas) => {
                                        var divData = canvas.toDataURL('image/png');
                                        var divHeight = (canvas.height * imgWidth) / canvas.width;
                                        if (idx < elems.length - 1) {
                                            if (pageHeight > position + divHeight) {
                                                doc.addImage(
                                                    divData,
                                                    'PNG',
                                                    10,
                                                    position,
                                                    imgWidth,
                                                    divHeight
                                                );
                                                console.log('add Image');
                                                setTimeout(1000, 'Timeout adding page #' + idx);
                                                position += divHeight;
                                            } else {
                                                doc.addPage();
                                                console.log('add New Page');
                                                position = 10;
                                                console.log('position', position);
                                                doc.addImage(
                                                    divData,
                                                    'PNG',
                                                    10,
                                                    position,
                                                    imgWidth,
                                                    divHeight
                                                );
                                                console.log('add Image');
                                                setTimeout(1000, 'Timeout adding page #' + idx);
                                                position += divHeight;
                                            }
                                        } else {
                                            console.log('add last element');
                                            if (pageHeight > position + divHeight) {
                                                doc.addImage(
                                                    divData,
                                                    'PNG',
                                                    10,
                                                    position,
                                                    imgWidth,
                                                    divHeight
                                                );
                                                console.log('add Image');
                                                setTimeout(1000, 'Timeout adding page #' + idx);
                                                position += divHeight;
                                            } else {
                                                doc.addPage();
                                                console.log('add New Page');
                                                position = 10;
                                                console.log('position', position);
                                                doc.addImage(
                                                    divData,
                                                    'PNG',
                                                    10,
                                                    position,
                                                    imgWidth,
                                                    divHeight
                                                );
                                                console.log('add Image');
                                                setTimeout(1000, 'Timeout adding page #' + idx);
                                                position += divHeight;
                                            }
                                            doc.save('UmowaEDS.pdf');
                                        }
                                    });
                                });
                            }}
                        >
                            <svg
                                className="contract__icon contract__icon--download"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M19.1627 1.5C19.1627 0.671573 18.4911 0 17.6627 0C16.8343 0 16.1627 0.671573 16.1627 1.5V19.4311L9.74408 13.0124C9.15829 12.4267 8.20855 12.4267 7.62276 13.0124C7.03697 13.5982 7.03697 14.548 7.62276 15.1338L16.602 24.113C17.1878 24.6988 18.1376 24.6988 18.7234 24.113L27.7026 15.1338C28.2884 14.548 28.2884 13.5982 27.7026 13.0124C27.1169 12.4267 26.1671 12.4267 25.5813 13.0124L19.1627 19.4311V1.5ZM1.5 21.549C2.32843 21.549 3 22.2206 3 23.049V30.2324C3 30.7872 3.22038 31.3192 3.61265 31.7115C4.00492 32.1038 4.53696 32.3241 5.09171 32.3241H30.2337C30.7885 32.3241 31.3205 32.1038 31.7128 31.7115C32.105 31.3192 32.3254 30.7872 32.3254 30.2324V23.049C32.3254 22.2206 32.997 21.549 33.8254 21.549C34.6538 21.549 35.3254 22.2206 35.3254 23.049V30.2324C35.3254 31.5828 34.789 32.8779 33.8341 33.8328C32.8792 34.7877 31.5841 35.3241 30.2337 35.3241H5.09171C3.74131 35.3241 2.44621 34.7877 1.49133 33.8328C0.536447 32.8779 0 31.5828 0 30.2324V23.049C0 22.2206 0.671573 21.549 1.5 21.549Z"
                                />
                            </svg>
                        </button>
                         
                    </div>
                    <form
                        id="accept-contract-form"
                        method="post"
                        action=""
                        onSubmit={(e) => save(e)}
                    >
                        <div className="checkbox-group">
                            <input
                                className="form__checkbox"
                                type="checkbox"
                                name="accept-contract"
                                id="accept-contract"
                                onClick={() => setcheckbox(!checkbox)}
                                checked={checkbox}
                                required
                            />
                            <label className="form__label--checkbox" htmlFor="accept-contract">
                                Akceptuję warunki umowy
                            </label>
                        </div>

                        <div className="checkbox-group ">
                            <input
                                className="form__checkbox"
                                type="checkbox"
                                name="accept-contract1"
                                id="accept-contract1"
                                onClick={() => setcheckbox0(!checkbox0)}
                                checked={checkbox0}
                                required
                            />
                            <label className="form__label--checkbox" htmlFor="accept-contract1"  >
                                Akceptuję 
                                <Link>
                               <span className="link"  onClick={() => openInNewTab('https://taniec.com.pl/ch/regulamin/')}>{' Regulamin '}</span>  </Link>
                                i 
                                <Link><span className="link"  onClick={() => openInNewTab('https://taniec.com.pl/wp-content/uploads/2021/09/STATUT-EDS-dla-Dzieci-i-M%C5%82odzie%C5%BCy-%C5%9Ar%C3%B3dmie%C5%9Bcie.pdf')}>{' Statut'}</span>  </Link> 
                                
                            </label>
                        </div>
                        <div className="checkbox-group">
                            <input
                                className="form__checkbox"
                                type="checkbox"
                                name="accept-contract2"
                                id="accept-contract2"
                                onClick={() => setcheckbox1(!checkbox1)}
                                checked={checkbox1}
                                required
                            />
                            <label className="form__label--checkbox" htmlFor="accept-contract2">
                                Zgadzam się na rozpoczęcie świadczenia usługi przed upływem terminu do odstąpienia od umowy
                            </label>
                        </div>
                        <button
                            type="submit"
                            className={`btn-primary margin-top-32  
                            ${(validButton())? 'button-disabled' : '' }`}
                            value="Potwierdzam zawarcie umowy">Potwierdzam zawarcie umowy  
                        </button>
                      
                    </form>
                </main>
            </div>
            <div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};

export default Umowa;
